import images from "./images";

const data = [
  {
    name: "Volkswagen Tiguan",
    year: "2019",
    mileage: "19,855 km",
    transmission: "Automatic",
    fuel: "Diesel",
    price: "$34,888",
    isNew: false,
    isSold: false,
    photo: images.product1,
  },
  {
    name: "Toyota Highlander XLE",
    year: "2014",
    mileage: "69,000 km",
    transmission: "Automatic",
    fuel: "Gas",
    price: "$27,875",
    isNew: true,
    isSold: false,
    photo: images.product2,
  },
  {
    name: "Lexus RX 350 LUXURY",
    year: "2017",
    mileage: "39,850 km",
    transmission: "Automatic",
    fuel: "Gas",
    price: "$38,775",
    isNew: false,
    isSold: false,
    photo: images.product3,
  },
  {
    name: "Toyota Highlander LE A...",
    year: "2016",
    mileage: "104,000 km",
    transmission: "Automatic",
    fuel: "Gas",
    price: "$23,728",
    isNew: false,
    isSold: true,
    photo: images.product4,
  },
  {
    name: "Hyundai Elantra",
    year: "2017",
    mileage: "95,000  km",
    transmission: "Automatic",
    fuel: "Gas",
    price: "$11,788",
    isNew: false,
    isSold: false,
    photo: images.product5,
  },
  {
    name: "Mercedes-Benz GLE-Cl...",
    year: "2016",
    mileage: "59,800 km",
    transmission: "Automatic",
    fuel: "Diesel",
    price: "$38,878",
    isNew: false,
    isSold: false,
    photo: images.product6,
  },
  {
    name: "Toyota Venza AWD XLE...",
    year: "2015",
    mileage: "99,000 km",
    transmission: "Automatic",
    fuel: "Gas",
    price: "$18,620",
    isNew: false,
    isSold: true,
    photo: images.product7,
  },
  {
    name: "Lexus RX 350 F-SPORT",
    year: "2016",
    mileage: "86,000 km",
    transmission: "Automatic",
    fuel: "Gas",
    price: "$34,888",
    isNew: true,
    isSold: false,
    photo: images.product8,
  },
  {
    name: "Volkswagen Tiguan",
    year: "2019",
    mileage: "99,000 km",
    transmission: "Automatic",
    fuel: "Diesel",
    price: "$34,888",
    isNew: false,
    isSold: false,
    photo: images.product1,
  },
  {
    name: "Toyota Highlander XLE",
    year: "2014",
    mileage: "69,000 km",
    transmission: "Automatic",
    fuel: "Gas",
    price: "$27,875",
    isNew: false,
    isSold: false,
    photo: images.product2,
  },
  {
    name: "Lexus RX 350 LUXURY",
    year: "2017",
    mileage: "86,000 km",
    transmission: "Automatic",
    fuel: "Gas",
    price: "$38,775",
    isNew: false,
    isSold: false,
    photo: images.product3,
  },
  {
    name: "Toyota Highlander LE A...",
    year: "2016",
    mileage: "104,000 km",
    transmission: "Automatic",
    fuel: "Gas",
    price: "$23,728",
    isNew: false,
    isSold: false,
    photo: images.product4,
  },
  {
    name: "Volkswagen Tiguan",
    year: "2019",
    mileage: "19,855 km",
    transmission: "Automatic",
    fuel: "Diesel",
    price: "$34,888",
    isNew: true,
    isSold: false,
    photo: images.product1,
  },
  {
    name: "Toyota Highlander XLE",
    year: "2014",
    mileage: "69,000 km",
    transmission: "Automatic",
    fuel: "Gas",
    price: "$27,875",
    isNew: false,
    isSold: false,
    photo: images.product2,
  },
  {
    name: "Lexus RX 350 LUXURY",
    year: "2017",
    mileage: "39,850 km",
    transmission: "Automatic",
    fuel: "Gas",
    price: "$38,775",
    isNew: false,
    isSold: false,
    photo: images.product3,
  },
  {
    name: "Toyota Highlander LE A...",
    year: "2016",
    mileage: "104,000 km",
    transmission: "Automatic",
    fuel: "Gas",
    price: "$23,728",
    isNew: false,
    isSold: false,
    photo: images.product4,
  },
  {
    name: "Hyundai Elantra",
    year: "2017",
    mileage: "95,000 km",
    transmission: "Automatic",
    fuel: "Gas",
    price: "$11,788",
    isNew: false,
    isSold: false,
    photo: images.product5,
  },
  {
    name: "Mercedes-Benz GLE-Cl...",
    year: "2016",
    mileage: "59,800 km",
    transmission: "Automatic",
    fuel: "Diesel",
    price: "$38,878",
    isNew: false,
    isSold: false,
    photo: images.product6,
  },
  {
    name: "Toyota Venza AWD XLE...",
    year: "2015",
    mileage: "99,000 km",
    transmission: "Automatic",
    fuel: "Gas",
    price: "$18,620",
    isNew: false,
    isSold: false,
    photo: images.product7,
  },
  {
    name: "Lexus RX 350 F-SPORT",
    year: "2016",
    mileage: "86,000 km",
    transmission: "Automatic",
    fuel: "Gas",
    price: "$34,888",
    isNew: true,
    isSold: false,
    photo: images.product8,
  },
  {
    name: "Volkswagen Tiguan",
    year: "2019",
    mileage: "19,855 km",
    transmission: "Automatic",
    fuel: "Diesel",
    price: "$34,888",
    isNew: false,
    isSold: false,
    photo: images.product1,
  },
  {
    name: "Toyota Highlander XLE",
    year: "2014",
    mileage: "69,000 km",
    transmission: "Automatic",
    fuel: "Gas",
    price: "$27,875",
    isNew: false,
    isSold: false,
    photo: images.product2,
  },
];

export default data;
